
<a id="mbfs-header-login-cta" id="auto_trigger" class="mbfs-header-login-cta-a" href="javascript:void(0)" (click)="onClickLogin($event)" hidden></a> 

<!-- Login Modal check user-->
 <form *ngIf="openLoginModal">
  <div class="mbfs-bank-profile-create-modal mbfs-modal" focustrapper aria-live="polite"
  [attr.aria-hidden]="openLoginModal" [class.open]="this.openLoginModal === true">
    <div class="mbfs-modal-overlay"></div> 

    <div *ngIf="!emailCountValid && !emailCountnotValid" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 1000; display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;">
      <div class="mbfs-loading-spinner-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0, 0, 0, 0.5);"></div>
      <div class="mbfs-loading-spinner"></div>
    </div>
  

    <!--If user Exists and and password does not need to be reset -->
     <div class="mbfs-modal-content" *ngIf="emailCountValid"> 
        <h3 class="mbfs-modal-header">{{ 'LoginModal.ResetPassword' | translate }}</h3>
        <div class="mbfs-bank-profile-create-inner"> 
          <div class ="registrationlinks">
            <p class="mbfs-passwordreset-title" >{{ 'LoginModal.EmailSent' | translate }} {{this.customerEmail}}</p>
          </div>
           <div class ="registrationlinks">
            <p class="mbfs-passwordreset-p" >{{ 'LoginModal.RegisterVerbiage' | translate }}</p>
           </div>
          <div class ="registrationlinks">
            <p class="mbfs-passwordreset-p" >{{ 'LoginModal.RegisterVerbiage1' | translate }}</p>
           </div>

          <button type="submit" class="mbfs-button" (click)="getPasswordResetStepOne()">{{ 'LoginModal.ResendLink' | translate }}</button>
          <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
            <br>
        </div>
        <div class ="registrationlinks">
         <p class="mbfs-passwordreset-p" >{{ 'LoginModal.Registerhref' | translate }}</p>
        </div><br>
        <button type="submit" *ngIf="this.admincheck !='true'" class="mbfs-button" (click)="reregister()" >{{ 'LoginModal.ReRegister' | translate }}</button>
        
     </div>
    <!--Password Reset Confirm Page -->
    <div class="mbfs-modal-content" *ngIf="emailCountnotValid"> 
      <h3 class="mbfs-modal-header">{{ 'LoginModal.ResetPassword' | translate }}</h3>
      <div class="mbfs-bank-profile-create-inner"> 
          <p class="mbfs-passwordreset-p">{{ 'LoginModal.Attempts' | translate }} </p>
        <button type="submit" class="mbfs-button" *ngIf="this.admincheck !='true'" (click)="reregister()" >{{ 'LoginModal.ReRegister' | translate }}</button>                
        <button type="submit" class="mbfs-button" (click)="closeCIAMModal($event)">{{ 'LoginModal.Continue' | translate }}</button>
        <button type="link" class="link mbfs-modal-close" (click)="closeCIAMModal($event)">X</button>
      </div>
    </div>
</div> 
</form> 
<div class="mbfs-modal-overlay"></div>

    


